function applyStrikethrough(html) {
    return html;
}

export default applyStrikethrough;
